import assign from 'lodash-es/assign'
import { environment } from '@environments/environment'

export class BaseModel {
  fileUrl?: string

  constructor(src?: unknown) {
    this.fileUrl = environment.fileUrl

    if (src) {
      assign(this, omitGetterOnlyProps(this, src))
    }
  }
}

// TODO(BE-contract): Remove this guard once BE stops returning computed fields like `fullName`.
// See local-docs/reports/admin-api-be-contract.md — BE must NOT include FE-computed fields in
// nested user objects (manager, salesManager, keyContact, etc).
//
// Why this guard exists: BE currently returns `manager: { fullName: "X Y" }`. FE `User` model
// defines `fullName` as getter-only (computed from name + surname). Direct `Object.assign` on
// such getter-only props throws TypeError, crashing `.map(toClient)` and emptying the table.
function omitGetterOnlyProps(target: object, src: unknown): object {
  if (!src || typeof src !== 'object') return src as object
  const result: Record<string, unknown> = {}
  for (const key of Object.keys(src as Record<string, unknown>)) {
    if (isGetterOnly(target, key)) continue
    result[key] = (src as Record<string, unknown>)[key]
  }
  return result
}

function isGetterOnly(target: object, key: string): boolean {
  let proto = Object.getPrototypeOf(target)
  while (proto && proto !== Object.prototype) {
    const desc = Object.getOwnPropertyDescriptor(proto, key)
    if (desc) return !!desc.get && !desc.set
    proto = Object.getPrototypeOf(proto)
  }
  return false
}
